module.exports = __webpack_public_path__ + "assets/img/00022.34bc38c7.png";